jQuery(function($){
	const parentSelector = '.sc-email-list-manager--detail-lists'

	const ajaxActionMap = {
		// ForwardMX Actions
	    sc_email_list_manager__forwardmx_add_list: forwardmx_add_list,
	    sc_email_list_manager__forwardmx_update_list: forwardmx_update_list,
	    sc_email_list_manager__forwardmx_delete_list: forwardmx_delete_list,

		// Google Workspace Actions
	    sc_email_list_manager__google_workspace_load_list_members: google_workspace_load_list_members,
	    sc_email_list_manager__google_workspace_load_list_settings: google_workspace_load_list_settings,
	    sc_email_list_manager__google_workspace_add_list: google_workspace_add_list,
	    sc_email_list_manager__google_workspace_add_list_submit: google_workspace_add_list_submit,
	    sc_email_list_manager__google_workspace_delete_list: google_workspace_delete_list,

	    sc_email_list_manager__google_workspace_add_member: google_workspace_add_member,
	    sc_email_list_manager__google_workspace_remove_member: google_workspace_remove_member,
	};

	$(parentSelector).on('click', '[admin-ajax-action]', function(e){
		e.preventDefault();

		console.log('clicked')
		const el = $(this);
		const ajaxAction = el.attr('admin-ajax-action');
		ajaxActionMap[ajaxAction](el);
	});


	//====================================================================================
	// ForwardMX Actions
	//====================================================================================

	// ---------- Add List ----------
	function forwardmx_add_list(el) {
		const hostname = el.attr('hostname');
		const buttonHtml = el.html();
		let forwarderAddress = window.prompt('Which forwarding address would you like to create? (____@' + hostname + ')');
		console.log('Creating ' + forwarderAddress + '@' + hostname);

		const data = {
			action: el.attr('admin-ajax-action'),
			source: forwarderAddress,
			domain: hostname,
			destination: ':fail:',
		};

		el.html('<div class="updating-field"><span class="fas fa-arrows-rotate fa-spin"></span> Creating Forwarder...</div>');

		$.post('/wp-admin/admin-ajax.php', data, function(response){
			let responseJson = JSON.parse(response);
			el.html(buttonHtml);
			
			if(responseJson.error) {
				window.alert(responseJson.error);
			} else {
				el.before(responseJson.markup);
			}
		});
	}
	
	// ---------- Update List ----------
	function forwardmx_update_list(el) {
		const parentDiv = el.closest('.detail-list');
		const addressList = parentDiv.find('.detail-list--details');
		const addressEdit = parentDiv.find('.detail-list--details-edit');

		const type = parentDiv.attr('type');
		const user = parentDiv.attr('address');
		const hostname = parentDiv.attr('hostname');

		let destination;
		if(type != 'emails') {
			destination = type;
		} else {
			let emails = [];
			parentDiv.find('input[type="email"]').each(function(){
				if($(this).val().length) emails.push($(this).val());
			});
			destination = emails.join();
		}

		console.log(hostname);
		console.log(type);
		console.log(destination);
		console.log(user);

		if(destination.length) {
			const data = {
				action: el.attr('admin-ajax-action'),
				domain: hostname,
				user: user,
				destination: destination,
			};

			console.log(data);

			addressEdit.html('<div class="updating-field"><span class="fas fa-arrows-rotate fa-spin"></span> Saving...</div>');
			$.post('/wp-admin/admin-ajax.php', data, function(response){
				let responseJson = JSON.parse(response);

				//Update html
				addressEdit.html(responseJson.edit);
				addressList.html(responseJson.display);

				parentDiv.removeClass('editing');
			});
		} else {
			window.alert('Cannot update with blank email');
		}
	}

	// ---------- Delete List ----------
	function forwardmx_delete_list(el) {
		const parentDiv = el.closest('.detail-list');
		const address = parentDiv.attr('address');
		const hostname = parentDiv.attr('hostname');
		const addressEdit = parentDiv.find('.detail-list--details-edit');

		let confirmDelete = window.confirm('Are you sure you want to delete this forwarder: ' + address + hostname + '?');
		console.log(confirmDelete);

		if(confirmDelete) {
			const data = {
				action: el.attr('admin-ajax-action'),
				user: address,
				domain: hostname,
			};

			console.log(data);

			addressEdit.html('<div class="updating-field"><span class="fas fa-arrows-rotate fa-spin"></span> Deleting...</div>');
			parentDiv.addClass('removing');
			$.post('/wp-admin/admin-ajax.php', data, function(response){
				let responseJson = JSON.parse(response);
				if(responseJson.error) {
					window.alert(responseJson.error);
				} else {
					window.alert(responseJson.message);
					parentDiv.remove();
				}
			});
		}
	}



	//====================================================================================
	// Google Workspace Actions
	//====================================================================================

	// ---------- List Members ----------
	function google_workspace_load_list_members(el) {
		const wrapperDiv = el.closest('.detail-list--subheading-wrapper');
		if(!wrapperDiv.hasClass('loaded-members')) {
			const parentDiv = el.closest('.detail-list');
			const editDiv = wrapperDiv.find('.detail-list--subheading-details-edit');

			const data = {
				action: el.attr('admin-ajax-action'),
				address: parentDiv.attr('address'),
			};

			editDiv.html('<div class="updating-field"><span class="fas fa-arrows-rotate fa-spin"></span> Loading Members...</div>');

			$.post('/wp-admin/admin-ajax.php', data, function(response) {
				console.log(response);
				responseJson = JSON.parse(response);
				console.log(responseJson);

				$(document).trigger('ajaxContentLoaded');

				if(responseJson.error) {
					editDiv.html(responseJson.error);
				} else {
					editDiv.html(responseJson.output);
					wrapperDiv.addClass('loaded-members');
				}
			});
		}
	}

	// ---------- List Settings ----------
	function google_workspace_load_list_settings(el) {
		const wrapperDiv = el.closest('.detail-list--subheading-wrapper');
		if(!wrapperDiv.hasClass('loaded-settings')) {
			const parentDiv = el.closest('.detail-list');
			const editDiv = wrapperDiv.find('.detail-list--subheading-details-edit');

			const data = {
				action: el.attr('admin-ajax-action'),
				address: parentDiv.attr('address'),
			};

			editDiv.html('<div class="updating-field"><span class="fas fa-arrows-rotate fa-spin"></span> Loading Settings...</div>');

			$.post('/wp-admin/admin-ajax.php', data, function(response) {
				console.log(response);
				const responseJson = JSON.parse(response);
				console.log(responseJson);

				$(document).trigger('ajaxContentLoaded');

				if(responseJson.error) {
					editDiv.html(responseJson.error);
				} else {
					editDiv.html(responseJson.output);
					wrapperDiv.addClass('loaded-settings');
				}
			});
		}		
	}

	// ---------- Add List Button ----------
	function google_workspace_add_list(el) {
		$('#add-list-modal').addClass('showing');
	}

	// ---------- Add List Submit ----------
	function google_workspace_add_list_submit(el) {
		const hostname = el.attr('hostname');
		const parentDiv = el.closest('.sc-field-editor');
		const buttonEl = $('[admin-ajax-action="sc_email_list_manager__google_workspace_add_list"]').first();
		const buttonHtml = buttonEl.html();

		//Get all form values
		let formValues = {};
		let formFields = [];
		parentDiv.find('input[ajax_field_name]').each(function(){
			formFields.push($(this));
			const key = $(this).attr('ajax_field_name');
			if(!formValues.hasOwnProperty(key)) formValues[key] = '';
			if($(this).attr('type') == 'radio') {
				if(this.checked) {
					formValues[key] = $(this).val();
				}
			} else {
				formValues[key] = $(this).val();
			}
		});

		let requirementsMet = true;
		$.each(formValues, function(key, value){
			if(key != 'description') {
				if(!value) requirementsMet = false;
			}
		});

		if(!requirementsMet) {
			window.alert('Please enter values for all required fields (List Address, Title, List Type)');
			return;
		}
		console.log(formValues, 'requirementsMet', requirementsMet);

		//Clear Fields
		$.each(formFields, function(){
			if($(this).attr('type') == 'radio') {
				if($(this)[0].checked) $(this)[0].checked = false;
			} else {
				$(this).val('');
			}			
		});

		//Close Modal
		el.closest('.scfe-modal-wrapper').removeClass('showing');

		// let addressPrefix = window.prompt('What should the address of your list be? (____@' + hostname + ')');
		const address = formValues.email + '@' + hostname;
		console.log('Creating ' + address);

		const data = {
			action: el.attr('admin-ajax-action'),
			address_prefix: formValues.email,
			domain: hostname,
			name: formValues.name,
			description: formValues.description,
		};
		console.log(data);

		buttonEl.html('<div class="updating-field"><span class="fas fa-arrows-rotate fa-spin"></span> Creating List...</div>').prop('disabled', true);

		$.post('/wp-admin/admin-ajax.php', data, function(response){
			console.log(response);
			let responseJson = JSON.parse(response);
			console.log(responseJson);


			if(responseJson.error) {
				window.alert(responseJson.error);
	
				//Restore button
				buttonEl.html(buttonHtml).prop('disabled', false);
			} else if(responseJson.result.error) {
				window.alert(responseJson.result.error.message + ': ' + address);
				buttonEl.html(buttonHtml).prop('disabled', false);
			} else {
				buttonEl.html('<div class="updating-field"><span class="fas fa-arrows-rotate fa-spin"></span> Updating default settings...</div>');
				setTimeout(function(){
					// el.before(responseJson.markup);
					const settingsData = {
						action: 'sc_email_list_manager__google_workspace_default_settings_after_add_list',
						address: address,
						whoCanPostMessage: formValues.whoCanPostMessage,
					};
					$.post('/wp-admin/admin-ajax.php', settingsData, function(settingsResponse){
						console.log(settingsResponse);
						let settingsResponseJson = JSON.parse(settingsResponse);
						console.log(settingsResponseJson);
	
						buttonEl.html('<div class="updating-field"><span class="fas fa-arrows-rotate fa-spin"></span> Saving...</div>');
		
						//Save Title to refresh settings
						setTimeout(function(){
							const updateNameData = {
								action: 'sc_email_list_manager__google_workspace_update_list_settings',
								address: address,
								field_name: 'name',
								value: formValues.name,
							};

							$.post('/wp-admin/admin-ajax.php', updateNameData, function(updateNameResponse){
								console.log(updateNameResponse);
								updateNameResponseJson = JSON.parse(updateNameResponse);
								console.log(updateNameResponseJson);

								//Restore button
								buttonEl.html(buttonHtml).prop('disabled', false);

								//Show item
								buttonEl.before(responseJson.markup);

								//Update Tags
								const tagsData = {
									action: 'sc_email_list_manager__google_workspace_update_heading_tags',
									result: updateNameResponseJson.result,
								};

								console.log(tagsData);

								$.post('/wp-admin/admin-ajax.php', tagsData, function(tagsResponse){
									$('#' + getSafeAddress(address) + '--heading-tags').html(tagsResponse);
								});
							});
						}, 2000);
					});
				}, 500);
			}
		});
	}

	// ---------- Delete List ----------
	function google_workspace_delete_list(el) {
		const parentDiv = el.closest('.detail-list');
		const address = el.attr('address');
		const memberCount = $('#' + getSafeAddress(address) + '--member-count').attr('member-count');

		if(parseInt(memberCount) > 0) {
			window.alert('This list (' + address + ') still has members.  Please remove members before deleting');
			return;
		}

		let confirmDelete = window.confirm('Are you sure you want to delete this list: ' + address + '?');
		console.log(confirmDelete);

		if(confirmDelete) {
			const data = {
				action: el.attr('admin-ajax-action'),
				address: address,
			};

			el.html('<div class="updating-field"><span class="fas fa-arrows-rotate fa-spin"></span> Deleting...</div>');
			parentDiv.addClass('removing');
			$.post('/wp-admin/admin-ajax.php', data, function(response){
				console.log(response)
				const responseJson = JSON.parse(response);
				console.log(responseJson)
				if(responseJson.error) {
					window.alert(responseJson.error);
				} else {
					window.alert(responseJson.message);
					parentDiv.remove();
				}
			});
		}
	}

	// ---------- Add Member ----------
	function google_workspace_add_member(el) {
		const address = el.attr('address');
		const parentDiv = el.closest('.sc-field-editor');
		const fields = parentDiv.find('input[ajax_field_name]');

		const buttonEl = $('[target="#' + getSafeAddress(address) + '--add-member-modal"]').first();
		const buttonHtml = buttonEl.html();

		//Get all form values
		let formValues = {};
		let formFields = [];
		parentDiv.find('input[ajax_field_name]').each(function(){
			formFields.push($(this));
			const key = $(this).attr('ajax_field_name');
			if(!formValues.hasOwnProperty(key)) formValues[key] = '';
			if($(this).attr('type') == 'radio') {
				if(this.checked) {
					formValues[key] = $(this).val();
				}
			} else if(key == 'address') {
				let addressValues = {};
				parentDiv.find('input[ajax_field_name="address"]').each(function(){
					const typeaheadType = $(this).attr('typeahead-type');
					addressValues[typeaheadType] = $(this).val();
				});

				if(addressValues.value) {
					const addressValueJson = JSON.parse(addressValues.value);
					if(addressValueJson.length) {
						formValues[key] = addressValueJson[0];
					} else if(addressValues.type) {
						formValues[key] = addressValues.type;
					}
				} else if(addressValues.type) {
					formValues[key] = addressValues.type;
				}
				console.log(addressValues);
			} else {
				formValues[key] = $(this).val();
			}
		});

		const isValidEmail = email => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

		let requirementsMet = true;
		$.each(formValues, function(key, value){
			if(key == 'member_type') {
				if(!value) {
					window.alert('Please select an option for Member Type');
					requirementsMet = false;
				}
			} else if(key == 'address') {
				if(!isValidEmail(value)) {
					window.alert('Invalid Email (' + value + ')');
					requirementsMet = false;
				}
			}
		});

		console.log(formValues);
		if(!requirementsMet) return;

		//Clear Fields
		$.each(formFields, function(){
			if($(this).attr('type') == 'radio') {
				if($(this)[0].checked) $(this)[0].checked = false;
				if($(this).val() == 'MEMBER') $(this)[0].checked = true;
			} else if($(this).hasClass('typeahead-input')) {
				$(this).val('').show();
				$(this).closest('.field').find('.selected').html('');
			} else {
				$(this).val('');
			}			
		});

		//Close Modal
		el.closest('.scfe-modal-wrapper').removeClass('showing');

		const data = {
			action: el.attr('admin-ajax-action'),
			address: address,
			email: formValues.address,
			role: formValues.member_type,
		};
		console.log(data);

		buttonEl.html('<div class="updating-field"><span class="fas fa-arrows-rotate fa-spin"></span> Adding Member...</div>').prop('disabled', true);

		$.post('/wp-admin/admin-ajax.php', data, function(response){
			console.log(response);
			let responseJson = JSON.parse(response);
			console.log(responseJson);


			if(responseJson.error) {
				window.alert(responseJson.error);
	
				//Restore button
				buttonEl.html(buttonHtml).prop('disabled', false);
			} else if(responseJson.result.error) {
				window.alert(responseJson.result.error.message + ': ' + address);
				buttonEl.html(buttonHtml).prop('disabled', false);
			} else {
				buttonEl.html(buttonHtml).prop('disabled', false);
				const memberListDiv = buttonEl.closest('.list-members-wrapper').find('.list-members').first();
				memberListDiv.append(responseJson.output);
				updateMemberCount(memberListDiv, address);

				$(document).trigger('ajaxContentLoaded');
			}
		});
	}

	function updateMemberCount(memberListDiv, address) {
		const memberCount = memberListDiv.find('> .list-member').length;
		const memberCountLabel = memberCount == 1 ? 'Member' : 'Members';
		$('#' + getSafeAddress(address) + '--member-count').attr('member-count', memberCount).html(memberCount + ' ' + memberCountLabel);		
	}

	// ---------- Remove Member ----------
	function google_workspace_remove_member(el) {
		const memberListDiv = el.closest('.list-members');
		const parentDiv = el.closest('.list-member');
		const listAddress = el.attr('address');
		const memberEmail = el.attr('member_email');
		const memberCount = $('#' + getSafeAddress(listAddress) + '--member-count').attr('member-count');

		const typeLabel = $('#' + getSafeAddress(memberEmail) + '__' + getSafeAddress(listAddress) + '--member-type-label');
		if(typeLabel.hasClass('MANAGER')) {
			window.alert('This member cannot be deleted as an Editor.  Please change status to Member to delete.');
			return;
		}
		if(typeLabel.hasClass('OWNER')) {
			window.alert('This member cannot be deleted as an Owner.  Please change status to Member to delete.');
			return;
		}

		let confirmRemove = window.confirm('Are you sure you want to remove this member (' + memberEmail + ') delete this list: ' + listAddress + '?');
		console.log(confirmRemove);

		if(confirmRemove) {
			const data = {
				action: el.attr('admin-ajax-action'),
				member_email: memberEmail,
				list_address: listAddress,
			};

			el.html('<div class="updating-field"><span class="fas fa-arrows-rotate fa-spin"></span> Deleting...</div>');
			$.post('/wp-admin/admin-ajax.php', data, function(response){
				console.log(response)
				const responseJson = JSON.parse(response);
				console.log(responseJson)

				if(responseJson.error) {
					window.alert(responseJson.error);
				} else {
					window.alert(responseJson.message);
					parentDiv.remove();
					setTimeout(function(){
						updateMemberCount(memberListDiv, listAddress);
					}, 100);
				}
			});
		}
	}

});